import axios from 'axios'
import router from '@/router'
import crypto from 'crypto-js'

let envArr = ['https://api.zydbai.com/tenant/', "http://10.10.10.235:8012/"];

// 上传图片地址
export function uploadImgUrl() {
    return 'https://api.zydbai.com/tenant/';
}

//上传图片地址
export function globalUrl() {
    return envArr[0];
}

//pdf预览地址
export function pdfPreviewUrl() {
    return envArr[1];
}

/**
 * ajax get/post 请求封装
 * @param serve 接口地址
 * @param params 请求传参
 * @param method 请求方式(get/post)
 */
export function request(serve, params = {}, method = 'get', responseType = '') {
    let url = envArr[0] + serve;
    const token = sessionStorage.getItem("token");
    return new Promise(function (resolve, reject) {
        let data = null;
        if (method.toLocaleLowerCase() === 'get' || method.toLocaleLowerCase() === 'delete') {
            data = 'params';
        } else {
            data = 'data';
        }
        let queryString = setObjectData(params, method)
        if (token) {
            queryString += queryString ? `&satoken=${token}` : `satoken=${token}`
        }
        // 使用HMAC-SHA256算法生成签名
        let signature = crypto.HmacSHA256(queryString, 'your-secret-key').toString(crypto.enc.Hex);
        var obj = {
            method,
            url,
            [data]: params,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                satoken: token,
                XSignature: signature,
            }
        }
        if (responseType != '') {
            obj.responseType = responseType
        }
        axios(obj).then((response) => {
            if (response.status) {
                if (responseType == '') {
                    resolve(response.data);
                } else {
                    resolve(response);
                }
            }
        }, err => {
            let response = err.response;
            const status = response.status;
            if (status === 401) {
                sessionStorage.clear();//清除缓存
                router.push({path: '/'});//返回登录页
            }
            reject(err)
        })
    })
}

//下载
export function download(url, method) {
    return new Promise(function (resolve, reject) {
        let obj = {
            method,
            url,
            dataType: "jsonp",//数据类型为jsonp
            params: {},
            headers: {},
            responseType: 'blob'
        }
        axios(obj).then((response) => {
            if (response.status) {
                resolve(response.data);
            }
        }, err => {
            reject(err)
        })
    })
}

//文件上传
export function upLoadFile(uploadFolder, data) {
    const token = sessionStorage.getItem("token");
    return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(data)
        //异步执行函数
        fileReader.onload = function (e) {
            let xhr = new XMLHttpRequest();
            xhr.open("POST", envArr[0] + 'zyd-common/file/upload?uploadPath=' + uploadFolder);
            xhr.setRequestHeader("Authorization", token);
            xhr.setRequestHeader("satoken", token);
            let formData = new FormData();
            formData.append('file', data);
            xhr.send(formData);
            //监听状态
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    resolve(JSON.parse(xhr.responseText).data);
                }
            }
        }
    });
}


function setObjectData(objectData, method) {
    let objData = Object.keys(objectData)
        .map(key => {
            if (objectData[key] === undefined || objectData[key] === null) {
                return `${enhancedEncodeURIComponent(key)}=`
            }
            if (Array.isArray(objectData[key])) {
                if (method.toLocaleLowerCase() === 'delete') {
                    let arrayData = objectData[key].map(item => {
                        return key + '[]=' + item
                    }).join('&')
                    return arrayData
                } else {
                    let value = setArrayData(objectData[key])
                    return `${enhancedEncodeURIComponent(key)}=${value}`
                }
            } else if (isObject(objectData[key])) {
                let value = setObjectData(objectData[key], method)
                return `${enhancedEncodeURIComponent(key)}={${value}}`
            } else if (typeof objectData[key] === 'string') {
                return `${enhancedEncodeURIComponent(key)}=${objectData[key]}`
            } else {
                return `${enhancedEncodeURIComponent(key)}=${enhancedEncodeURIComponent(objectData[key])}`
            }
        })
    objData = objData.filter(item => item != '').join('&');
    return objData
}

function enhancedEncodeURIComponent(str) {
    let allString = ''
    str += ''
    let leng = str.length
    for (let i = 0; i < leng; i++) {
        let item = str[i]
        if (item == '-' || item == '_' || item == '.' || item == '!' || item == '~' || item == '*' || item == '\'' || item == '(' || item == ')' || item == '（' || item == '）') {
            allString += item
        } else {
            allString += encodeURIComponent(item)
        }
    }
    return allString
}

function setArrayData(arrayList) {
    return JSON.stringify(arrayList)
}

function isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
